import React from 'react'
import {
  ApolloClient,
  ApolloProvider,
  HttpLink,
  InMemoryCache,
} from '@apollo/client'
import fetch from 'isomorphic-fetch'

const client = new ApolloClient({
  link: new HttpLink({
    uri: process.env.GATSBY_WT_API_URL,
    fetch,
  }),
  cache: new InMemoryCache(),
  ssrMode: typeof window === 'undefined',
})

export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>{element}</ApolloProvider>
)
